import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {IOktoberfestGameData} from "./server/data/IOktoberfestData";
import {OktoberfestGameMode} from "./server/OktoberfestGameMode";
import {OktoberfestSound} from "./sound/OktoberfestSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class OktoberfestPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            hasActionSpin: true,
            gameName: "Oktoberfest",
            graphics: {
                backgroundTextureName: "background/oktoberFestASBg" //Loaded in intro view config.
            },
            getParsedData: (response: IOktoberfestGameData, bet: number, prevResponse: IOktoberfestGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: parseFloat(response.accumulatedRoundWin),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.freeSpinTriggeredThisSpin(response),
                    totalSpinWinnings: this.getWin(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.AS_WIN});
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.AS_WIN_BIG});
        }
    }

    private freeSpinTriggeredThisSpin(response: any): boolean {
        return response.freespinTriggeredThisSpin || (response.respinsLeft === 2 && response.mode === "WILD_RESPIN" && response.nextMode === "WILD_RESPIN");
    }

    private isBigWin(response: IOktoberfestGameData): boolean {
        const win = this.getWin(response);
        const playedBetValue = parseFloat(response.playedBetValue);
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
        return winRatio >= 15;
    }

    private getWin(response: IOktoberfestGameData): number {
        return parseFloat(response.totalSpinWinnings);
    }

    private getFeatureName(response: IOktoberfestGameData): string {
        if (response.mode === GameMode.FREESPIN || response.nextMode === GameMode.FREESPIN) {
            return "BIER SPINS";
        }
        if (response.mode === "WILD_RESPIN" || response.nextMode === "WILD_RESPIN") {
            return "PROST SPINS";
        }
        return "";
    }

    private isRoundComplete(response: IOktoberfestGameData): boolean {
        return ([OktoberfestGameMode.FREESPIN, OktoberfestGameMode.FREESPIN_SUPER, OktoberfestGameMode.NORMAL, "WILD_RESPIN"].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IOktoberfestGameData): boolean {
        return response.nextMode === OktoberfestGameMode.NORMAL && (response.mode === OktoberfestGameMode.FREESPIN || response.mode === "WILD_RESPIN");
    }
}
